import React from "react";
import { localize } from "redux-i18n";
import { connect } from "react-redux";
import { ReportAreas } from "@modules/reporting/components/report-areas";
import type { State } from "@store/reducers";
import { Label, Form, FormGroup, Button, Icon } from "@components";
import { Field, reduxForm } from "redux-form";
import { getMyHierarchyTree } from "@modules/shared/selectors";
import { getSlaPerformanceSelectedAndExcluded } from "@modules/client/selectors/index.js";
import { DatePickerFormWrapper, Dropdown } from "@components/form";
import { getFormValues } from "redux-form";
import config from "@config";

type OwnProps = $Exact<{
  handleTreeUpdate: Function,
  handleSubmit: Function,
}>;

type PropsFromState = $Exact<{
  formValues: ?Object,
  hierarchyTree: ?Object,
  slaPerformanceSelectedAndExcluded: { scope: { selected: [], excluded: [] } },
}>;

const mapStateToProps = (state: State): PropsFromState => ({
  formValues: getFormValues("SlaPerformanceFilters")(state),
  hierarchyTree: getMyHierarchyTree(state),
  slaPerformanceSelectedAndExcluded: getSlaPerformanceSelectedAndExcluded(state),
});

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
}>;
export class SlaPerformanceFiltersSection extends React.Component<Props> {
  get periodTypes() {
    return [
      { label: "Weekly", value: "WEEKLY" },
      { label: "Monthly", value: "MONTHLY" },
      { label: "Quarterly", value: "QUARTERLY" },
    ];
  }

  get requiredIcon() {
    return <Icon icon="asterisk" size="xs" className="text-warning ml-2" />;
  }
  validateAreas() {
    return this.props.slaPerformanceSelectedAndExcluded.selected.length > 0;
  }
  validate(value: *) {
    if (!value) {
      return "Required";
    }
    return undefined;
  }

  render() {
    return (
      <React.Fragment>
        {this.props.hierarchyTree && (
          <ReportAreas
            className="d-flex p-2 w-100 pb-5"
            editable={true}
            selected={this.props.slaPerformanceSelectedAndExcluded.selected}
            excluded={this.props.slaPerformanceSelectedAndExcluded.excluded}
            onTreeUpdate={this.props.handleTreeUpdate}
            organizationStructure={this.props.hierarchyTree}
            t={this.props.t}
          />
        )}

        <Form onSubmit={this.props.handleSubmit} className="d-flex w-100 justify-content-start">
          <FormGroup className="w-50 p-2">
            <Label for="fromDate" className="small-font-size text-grey">
              {this.props.t("START_DATE")}
              {this.requiredIcon}
            </Label>
            <Field
              validate={[this.validate]}
              name="from_date"
              component={DatePickerFormWrapper}
              customProps={{
                dateFormat: config.dateFormatBE,
                maxDate: (this.props.formValues || {}).to_date,
                id: "fromDate",
              }}
            />
          </FormGroup>
          <FormGroup className="w-50 p-2">
            <Label for="toDate" className="small-font-size text-grey">
              {this.props.t("END_DATE")} {this.requiredIcon}
            </Label>
            <Field
              validate={[this.validate]}
              name="to_date"
              component={DatePickerFormWrapper}
              customProps={{
                dateFormat: config.dateFormatBE,
                minDate: (this.props.formValues || {}).from_date,
                id: "toDate",
              }}
            />
          </FormGroup>
          <FormGroup className="w-50 p-2">
            <Label for="periodType" className="small-font-size text-grey">
              {this.props.t("PERIOD_TYPE")} {this.requiredIcon}
            </Label>
            <Field
              validate={[this.validate]}
              id="periodType"
              name="period_type"
              component={Dropdown}
              options={this.periodTypes}
            />
          </FormGroup>
          <div className="d-flex p-2  w-100 justify-content-end">
            <Button
              disabled={!this.props.valid || !this.validateAreas()}
              className="mt-3 form-group"
              onClick={this.props.handleSubmit}
              materialIcon="replay_circle_filled"
            >
              {this.props.t("SUBMIT")}
            </Button>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}
export default reduxForm({
  form: "SlaPerformanceFilters",
})(connect(mapStateToProps)(localize()(SlaPerformanceFiltersSection)));
